<template>
  <YhcEFConfigControlsForPreview v-if="isPreviewMode" />
  <div
    class="yhc-es-form"
    :class="{
      'yhc-es-form--is-preview-mode': isPreviewMode,
    }"
  >
    <div
      class="yhc-es-form--inner"
      v-if="initialized"
    >
      <ModelForm
        :model-name="'yhc_estimate_form'"
        :disable-confirm-before-submit="true"
        :hide-footer="true"
      />
    </div>
  </div>
</template>
<script lang="ts">
import YhcEFConfigControlsForPreview from './components/YhcEFConfigControlsForPreview.vue'
import { YhcEstimateFormFrontService } from './YhcEstimateFormFrontService'
import './components/_yhc-estimate-form-front.scss'
import { reactive } from 'vue'

/**
 * Web見積りフォーム 全体を Wrap するコンポーネント
 *
 * ## 責任範囲
 * - Service Class `YhcEstimateFormFrontService` の 初期化 & provide
 * - コンポーネントの羅列
 */
export default {
  name: 'YhcEstimateForm',
  props: {
    isPreviewMode: {
      type: Boolean,
      default: false,
    },
    autoInit: {
      type: Boolean,
      default: true,
    },
    enableAutoSaveOfUserInputData: {
      type: Boolean,
      default: false,
    },
  },
  components: { YhcEFConfigControlsForPreview },
  data() {
    return {
      YhcEstimateFormFrontServiceInstance: reactive(new YhcEstimateFormFrontService()),
      initialized: false,
    }
  },
  provide() {
    return {
      YhcEstimateFormFrontServiceInstance: this.YhcEstimateFormFrontServiceInstance,
    }
  },
  async mounted() {
    if (this.autoInit) {
      await this.init()
    }
  },
  methods: {
    async init() {
      this.initialized = false
      if (this.enableAutoSaveOfUserInputData) {
        this.YhcEstimateFormFrontServiceInstance.enableAutoSaveOfUserInputData = true
      }
      await this.YhcEstimateFormFrontServiceInstance.init()
      this.$nextTick(() => {
        this.initialized = true
      })
    },
  },
}
</script>
